var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader'),_vm._v(" "),_c('section',{attrs:{"id":"act_rules"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"list-wrap"},[_c('div',{staticClass:"main-title"},[_c('h1',[_vm._v(_vm._s(_vm.all_datas.title))])]),_vm._v(" "),_c('mylist',{attrs:{"rule_datas":_vm.all_datas.activity_rules}})],1)])])]),_vm._v(" "),_c('ToTopBtn')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55488467","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ActRules/main.vue
// module id = 196
// module chunks = 0